import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mail_163.svg';
const Mail163 = () => React.createElement(IconSvg, null);
export default Mail163;
